// extracted by mini-css-extract-plugin
module.exports = {"first-level-tabs":"FirstLevelTabs_first-level-tabs__Qwhi4","active":"FirstLevelTabs_active__zueqr"};